import React from 'react';
import { useLocation } from 'react-router-dom';
import { Header } from './Header';
import { Footer } from './Footer';
export function Layout({
  children
}: {
  children: React.ReactNode;
}) {
  const {
    pathname
  } = useLocation();
  const showPreviousVersionLink = pathname === '/';
  return <div className="flex min-h-screen w-full max-w-full flex-col overflow-x-hidden bg-white" data-id="element-129" data-mp="uyksaz99jqmd">
      <div className="relative box-border w-full max-w-full overflow-hidden border-b border-slate-200 bg-slate-100 py-1.5 text-slate-600" data-id="element-130" data-mp="78gyfjlvn58k">
        <div className={`mx-auto w-full max-w-full box-border whitespace-normal break-words px-3 text-center text-[12px] font-medium leading-tight sm:px-4 sm:text-xs xl:text-[13px] ${showPreviousVersionLink ? 'pr-32 sm:pr-4' : ''}`} data-id="element-131" data-mp="2aymdkckc9wc">
          <span className="block sm:inline" data-id="element-132" data-mp="c5qo90d6hiwx">
            Medical modality equipment, training &amp; support
          </span>
          <span className="hidden sm:inline" data-id="element-133" data-mp="3fos6wivu88rq"> </span>
          <span className="block sm:inline" data-id="element-134" data-mp="3fo0lu1zv9tfp">
            for chiropractic, rehab &amp; wellness practices.
          </span>
        </div>
        {showPreviousVersionLink && <a href="/previous-version-2026-07-23.html" target="_blank" rel="noopener noreferrer" className="absolute right-3 top-1/2 -translate-y-1/2 whitespace-nowrap text-[10px] font-medium text-slate-600 transition-colors hover:text-navy hover:underline sm:right-4 sm:text-xs" data-id="element-135" data-mp="1msp985q4gegi">
            See previous version
          </a>}
      </div>
      <Header data-id="element-136" data-mp="13vo1we93i29e" />
      <main className="flex-1" data-id="element-137" data-mp="13v67zo9wo04n">{children}</main>
      <Footer data-id="element-138" data-mp="18tg3jzzjl2qs" />
    </div>;
}